import { AutoCompleteLocation } from "./useMapAutoComplete";
import React from "react";
import styled from "styled-components";
type SuggestionListItemProps = {
  item: AutoCompleteLocation;
  key: string;
  onClick: (item: AutoCompleteLocation) => void;
};
function SuggestionListItem(props: SuggestionListItemProps) {
  const {
    key,
    item,
    onClick
  } = props;
  const selectionMade = () => {
    onClick(item);
  };
  return <ListItem key={key} data-sentry-element="ListItem" data-sentry-component="SuggestionListItem" data-sentry-source-file="SuggestionListItem.tsx">
      <ListButton onClick={selectionMade} data-sentry-element="ListButton" data-sentry-source-file="SuggestionListItem.tsx">
        {item.displayLines.join(", ")}
      </ListButton>
    </ListItem>;
}
const ListItem = styled.li`
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  order-style: solid;
  width: 100%;
  min-height: 2rem;
  display: list-item;
  text-align: -webkit-match-parent;
  unicode-bidi: isolate;
  &:hover {
    /*
     * Was rgba(0, 0, 0, 0.1) — a hardcoded dark wash that would have
     * rendered as a near-invisible darkening on an already-dark --d-card
     * surface in dark theme. --d-tint matches the established convention
     * for a "hover, not yet selected" row wash elsewhere in the app (e.g.
     * SelectableButton, TimezoneList, IntervalListItem).
     */
    background: ${({
  theme
}) => theme.brand.cssVars["--d-tint"]};
    /*
     * --d-tint is always a light colour, even on dark-theme brands, so the
     * button's own --d-text (light/cream on the dark bucket) would be
     * light-on-light and unreadable on hover. --d-on-tint is computed to
     * contrast with --d-tint specifically (see theme.ts, same pairing
     * used by SelectableButton/DateButton's hover state).
     */
    button {
      color: ${({
  theme
}) => theme.brand.cssVars["--d-on-tint"]};
    }
  }
  &:first-child {
    border-botton: 0;
  }
`;
const ListButton = styled.button`
  text-align: left;
  cursor: pointer;
  -webkit-appearance: button;
  background-color: transparent;
  background-image: none;
  text-transform: none;
  min-height: inherit;
  width: 100%;
  border: 0;
  /*
   * Was unset — fell back to the browser default black text colour,
   * invisible against a dark-theme --d-card suggestions dropdown.
   */
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
`;
export default SuggestionListItem;